// istanbul ignore file
'use client';

import { CacheProvider } from '@emotion/react';
import Grid from '@mui/material/Grid';
import { useState } from 'react';

import { WAITLIST } from 'reservations/account/components/PageTitleHandler';
import { PageTitleContext } from 'reservations/account/providers/PageTitleProvider';
import Analytics from 'reservations/analytics/components/Analytics';
import { useRouterNav } from 'reservations/base/hooks/useRouterNavForAppRouter';
import ReservationsProvider from 'reservations/base/providers/ReservationsProvider';
import { RouterProvider } from 'reservations/base/providers/RouterProvider';
import setupAxeCore from 'utility/axeCoreTool';
import createEmotionCache from 'utility/createEmotionCache';
import { initializeDatadog } from 'utility/datadog';
import { initializeHeap } from 'utility/heap';
import { initializeSentry } from 'utility/sentry';
import { initializeSmartlook } from 'utility/smartlook';


// istanbul ignore file

initializeHeap();
initializeSentry();
initializeSmartlook();
initializeDatadog();
setupAxeCore();

const clientSideEmotionCache = createEmotionCache();

// istanbul ignore next
if (
  process.env.NEXT_PUBLIC_API_MOCKING === 'enabled' &&
  process.env.NODE_ENV !== 'production'
) {
  require('../mocks');
}

// TODO: DMD-5737 - Move over tests from _app file in pages directory
export default function RootLayout({
  children
}: {
  children: React.ReactNode;
}) {
  const { handleNavigation, handleOffRouteChange, handleOnRouteChange } =
    useRouterNav();

  const [faviconUrl, setFaviconUrl] = useState('');
  const [feature, setFeature] = useState(WAITLIST);
  const [restaurant, setRestaurant] = useState('');

  return (
    <html lang="en">
      <head>
        <title>{`${feature} | ${restaurant}`}</title>
        <meta
          name="viewport"
          content="minimum-scale=1, initial-scale=1, width=device-width"
        />
        {faviconUrl && (
          <link
            rel="icon"
            href={faviconUrl}
            type="image/<generated>"
            sizes="<generated>"
          />
        )}
      </head>
      <body>
        <CacheProvider value={clientSideEmotionCache}>
          <RouterProvider
            handleNavigation={handleNavigation}
            handleOffRouteChange={handleOffRouteChange}
            handleOnRouteChange={handleOnRouteChange}
          >
            <PageTitleContext.Provider
              value={{ setFaviconUrl, setFeature, setRestaurant }}
            >
              <ReservationsProvider>
                <Analytics />
                <Grid
                  container
                  direction="column"
                  wrap="nowrap"
                  sx={{ height: '100vh' }}
                >
                  <Grid item xs={11}>
                    {children}
                  </Grid>
                </Grid>
              </ReservationsProvider>
            </PageTitleContext.Provider>
          </RouterProvider>
        </CacheProvider>
      </body>
    </html>
  );
}
